module.exports = new __parcel__URL__("cegLogoWithoutName.258eab4b.png").toString();